import { useCallback, useEffect, useState } from "react";
import { api, apiErrorMessage } from "../lib/api";
import { toast } from "sonner";

/**
 * Owns the bonus-video modal state for the game-over flow:
 * - `bonusVideo` comes from /games/submit response when a token is issued
 * - Watch-time ticker auto-advances while the iframe plays
 * - `claim` validates min watch time server-side and credits BC
 */
export function useBonusVideo({ refreshUser }) {
  const [bonusVideo, setBonusVideo] = useState(null);
  const [bonusWatch, setBonusWatch] = useState(0);
  const [bonusClaiming, setBonusClaiming] = useState(false);

  useEffect(() => {
    if (!bonusVideo) return;
    setBonusWatch(0);
    const id = setInterval(() => setBonusWatch((w) => w + 1), 1000);
    return () => clearInterval(id);
  }, [bonusVideo]);

  const claim = useCallback(async () => {
    if (!bonusVideo) return;
    setBonusClaiming(true);
    try {
      const { data } = await api.post("/education/bonus-claim", {
        token: bonusVideo.token,
        watch_time: bonusWatch,
      });
      toast.success(`+${data.bc_earned} BC — bonus claimed!`);
      await refreshUser();
      setBonusVideo(null);
    } catch (e) {
      toast.error(apiErrorMessage(e));
    } finally {
      setBonusClaiming(false);
    }
  }, [bonusVideo, bonusWatch, refreshUser]);

  const skip = useCallback(() => {
    setBonusVideo(null);
  }, []);

  return { bonusVideo, setBonusVideo, bonusWatch, bonusClaiming, claim, skip };
}
